import { Link, useParams } from "react-router";
import { useDealDetail } from "src/dm/hooks/useDeals";
import DealForm from "src/dm/pages/DealForm/DealForm";

const DealEditPage = () => {
  const { dealId } = useParams<{ dealId: string }>();
  const id = dealId ? Number(dealId) : undefined;
  const { data, isLoading, isError, error } = useDealDetail(id);

  if (id === undefined || Number.isNaN(id)) return <p>Invalid deal id.</p>;
  if (isLoading) return <p>Loading deal {id}…</p>;
  if (isError) {
    const msg = error instanceof Error ? error.message : "unknown";
    return <p style={{ color: "#b91c1c" }}>Could not load deal {id}: {msg}</p>;
  }
  if (!data) return <p>Deal {id} not found.</p>;

  return (
    <div>
      <Link to={`/dm/deals/${id}`} style={{ display: "inline-block", marginBottom: "0.75rem", fontSize: "0.85rem", color: "#0a3d62", textDecoration: "none" }}>
        ← Back to deal
      </Link>
      <DealForm mode={{ kind: "edit", dealId: id }} initial={data} />
    </div>
  );
};

export default DealEditPage;
